import React from 'react';
import './User.css';

let User = props => {
    return (
        <div className="login-action loggedin">
            <img src={props.user.avatar} alt="avatar"/>
            <div>
                <span>Welcome</span>
                <b>{props.user.name}</b>
            </div>
        </div>
    );
};

export default User;



// WEBPACK FOOTER //
// ./src/components/Header/User/User.jsx